const AddIcon = ({ color = 'currentColor', height = '24px', width = '24px' }) => {
	return (
		// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
		// 	<path
		// 		d="M11.998 19.75C12.412 19.75 12.748 19.4142 12.748 19V12.75H19.0001C19.4141 12.75 19.7501 12.4142 19.7501 12C19.7501 11.5857 19.4141 11.25 19.0001 11.25H12.748V4.99805C12.748 4.58384 12.412 4.24805 11.998 4.24805C11.584 4.24805 11.248 4.58384 11.248 4.99805V11.25H4.99805C4.58405 11.25 4.24805 11.5857 4.24805 12C4.24805 12.4142 4.58405 12.75 4.99805 12.75H11.248V19C11.248 19.4142 11.584 19.75 11.998 19.75Z"
		// 		fill={color}
		// 	/>
		// </svg>
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<line x1="12" y1="5" x2="12" y2="19"></line>
			<line x1="5" y1="12" x2="19" y2="12"></line>
		</svg>
	);
};

export default AddIcon;
